import React from 'react';
import { motion } from 'framer-motion';

const Hero: React.FC = () => {
  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
  };

  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.6, delay: 0.5 } }
  };

  return (
    <section id="hero" className="hero">
      <div className="orb orb-1"></div>
      <div className="orb orb-2"></div>
      <div className="orb orb-3"></div>
      <div className="orb orb-4"></div>
      <div className="orb orb-5"></div>

      <motion.div className="hero-content" initial="hidden" animate="visible" variants={textVariants}>
        <motion.h1 variants={textVariants}>
          Transform Your Vision Into Digital Reality
        </motion.h1>
        <motion.p variants={textVariants}>
          We don't just build websites – we craft digital experiences that captivate audiences, drive conversions, and establish your brand as an industry leader. From concept to launch, we deliver excellence.
        </motion.p>

        {/* Text Marquee Animation */}
        <div className="text-marquee wow fadeInUp">
          <div className="marquee-content">
            ★ Award-Winning Designs ★ Cutting-Edge Technology ★ 100% Satisfaction ★ 24/7 Support ★
          </div>
        </div>

        <motion.div className="hero-buttons" variants={buttonVariants}>
          <a href="#portfolio" className="btn-primary">Explore Our Work</a>
          <a href="#contact" className="btn-secondary">Start Your Project</a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
